import React, { useState } from "react";
import "./Game.css";
import { Drawer, Space } from "antd";
import Game1 from "../Game's/Game1";
import Game2 from "../Game's/Game2";
import Game3 from "../Game's/Game3";
import Game4 from "../Game's/Game4";
import Game5 from "../Game's/Game5";

export default function Game() {
  const [page, setPage] = useState(1);

  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const [open2, setOpen2] = useState(false);
  const showDrawer2 = () => {
    setOpen2(true);
  };
  const onClose2 = () => {
    setOpen2(false);
  };

  const [open3, setOpen3] = useState(false);
  const showDrawer3 = () => {
    setOpen3(true);
  };
  const onClose3 = () => {
    setOpen3(false);
  };

  const [open4, setOpen4] = useState(false);
  const showDrawer4 = () => {
    setOpen4(true);
  };
  const onClose4 = () => {
    setOpen4(false);
  };

  const [open5, setOpen5] = useState(false);
  const showDrawer5 = () => {
    setOpen5(true);
  };
  const onClose5 = () => {
    setOpen5(false);
  };

  return (
    <div className="Game-Main-Body">
      <div className="Game-Main-Box">
        <button
          className="Game-Top-Button"
          onClick={() => {
            setPage(1);
          }}
          style={{
            color: page === 1 ? "#fb6565" : "#6f62e0",
            borderColor: page === 1 ? "#fb6565" : "#6f62e0",
          }}
        >
          Click Mover
        </button>
        <button
          className="Game-Top-Button"
          onClick={() => {
            setPage(2);
          }}
          style={{
            color: page === 2 ? "#fb6565" : "#6f62e0",
            borderColor: page === 2 ? "#fb6565" : "#6f62e0",
          }}
        >
          Game-2
        </button>
        <button
          className="Game-Top-Button"
          onClick={() => {
            setPage(3);
          }}
          style={{
            color: page === 3 ? "#fb6565" : "#6f62e0",
            borderColor: page === 3 ? "#fb6565" : "#6f62e0",
          }}
        >
          Memory Match
        </button>
        <button
          className="Game-Top-Button"
          onClick={() => {
            setPage(4);
          }}
          style={{
            color: page === 4 ? "#fb6565" : "#6f62e0",
            borderColor: page === 4 ? "#fb6565" : "#6f62e0",
          }}
        >
          Catch Items
        </button>
        <button
          className="Game-Top-Button"
          onClick={() => {
            setPage(5);
          }}
          style={{
            color: page === 5 ? "#fb6565" : "#6f62e0",
            borderColor: page === 5 ? "#fb6565" : "#6f62e0",
          }}
        >
          Snake Game
        </button>
      </div>

      {page === 1 ? (
        <div className="Game-Main-Div">
          <p className="Game-Text1">Click Mover</p>
          <p className="Game-Text2">
            Welcome to ClickMover! The objective of the game is simple: click
            the red box as many times as you can. Here's how to play:
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>
              1. Starting the Game:
            </span>{" "}
            The game starts when you click the red box for the first time. This
            action will also start the timer.
            <br />
            <span style={{ fontWeight: "bold" }}>2. Box Movement: </span> Each
            time you click the red box, it will move to a random position on the
            screen. Your score increases by 1 with each successful click.
            <br />
            <span style={{ fontWeight: "bold" }}>3. Timing: </span> You have a
            limited time of 2 seconds to click the box each time it appears. If
            you fail to click the box within this time, the game will end
            automatically.
            <br />
            <span style={{ fontWeight: "bold" }}>4. Missed Clicks: </span> If
            you click anywhere outside the red box, the game will end
            immediately. Precision is key!
            <br />
            <span style={{ fontWeight: "bold" }}>5. Scoring: </span> Your score
            is displayed on the screen, showing the number of times you
            successfully clicked the box. The timer will also display how long
            you have been playing since the first click.
            <br />
            <span style={{ fontWeight: "bold" }}>6. Game Over: </span> When the
            game ends, either by missing the box or running out of time, your
            final score and total time will be displayed. Use this information
            to challenge yourself and improve with each game!
            <br /> <br />
            <span style={{ fontWeight: "bold" }}>
              Enjoy the challenge and see how high you can score. Good luck and
              happy clicking!{" "}
            </span>
          </p>{" "}
          <button className="glow-on-hover" onClick={showDrawer}>
            Lat's Playing
          </button>
          <Drawer
            title="ClickMover"
            onClose={onClose}
            open={open}
            className="custom-drawer"
            width="100%"
            bodyStyle={{
              padding: 0,
              backgroundColor: "#1b2840",
              color: "white",
            }}
            extra={
              <Space>
                <div>{/* resive props */}</div>
                <button className="Game-DrawerClose-Button" onClick={onClose}>
                  Close
                </button>
              </Space>
            }
          >
            <Game1 />
          </Drawer>
        </div>
      ) : page === 2 ? (
        <div className="Game-Main-Div">
          <p className="Game-Text1">Game-2</p>
          <p className="Game-Text2">
            Welcome to .......
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>
              1. Starting the Game:
            </span>{" "}
            The game ....
            <br />
          </p>{" "}
          <button className="glow-on-hover" onClick={showDrawer2}>
            Lat's Playing
          </button>
          <Drawer
            title="ClickMover"
            onClose={onClose2}
            open={open2}
            className="custom-drawer"
            width="100%"
            bodyStyle={{
              padding: 0,
              backgroundColor: "#1b2840",
              color: "white",
            }}
            extra={
              <Space>
                <button className="Game-DrawerClose-Button" onClick={onClose2}>
                  Close
                </button>
              </Space>
            }
          >
            <Game2 />
          </Drawer>
        </div>
      ) : page === 3 ? (
        <div className="Game-Main-Div">
          <p className="Game-Text1">Memory Match Game</p>
          <p className="Game-Text2">
            Welcome to the Memory Match Game! Match all pairs of cards in the
            least amount of time and turns.
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>
              1. Starting the Game:
            </span>{" "}
            Click the "Start Game" button to begin. The timer will start and
            cards will be shuffled.
            <br />
            <span style={{ fontWeight: "bold" }}>2.Gameplay:</span>
            Click on a card to flip it. Click on a second card to try to find a
            match. If the two cards match, they will remain flipped. If the two
            cards do not match, they will flip back over after a short delay.
            Continue until all pairs are matched.
            <br />
            <span style={{ fontWeight: "bold" }}>3.Scoring:</span>
            Your score is determined by the time taken and the number of turns.
            The fewer turns and less time you take, the better your score.
            <br />
            <span style={{ fontWeight: "bold" }}>4.Inactivity Timer:</span>
            If there is no movement or clicks within 15 seconds, the game will
            automatically close. Your progress will be lost, and you will need
            to restart the game.
            <br />
            <span style={{ fontWeight: "bold" }}>5.Game Over:</span>
            When all pairs are matched, the game ends. Your final time and
            number of turns will be displayed. Click the "Restart Game" button
            to play again.
            <br />
            <span style={{ fontWeight: "bold" }}>Tips:</span>
            Focus on remembering the positions of the cards to improve your
            matching efficiency. Try to make matches as quickly as possible to
            improve your time score.
            <br />
            <br />
            Enjoy the challenge and have fun improving your memory and matching
            skills!
          </p>{" "}
          <button className="glow-on-hover" onClick={showDrawer3}>
            Lat's Playing
          </button>
          <Drawer
            title="Memory Match Game"
            onClose={onClose3}
            open={open3}
            className="custom-drawer"
            width="100%"
            bodyStyle={{
              padding: 0,
              backgroundColor: "#1b2840",
              color: "white",
            }}
            extra={
              <Space>
                <button className="Game-DrawerClose-Button" onClick={onClose3}>
                  Close
                </button>
              </Space>
            }
          >
            <Game3 />
          </Drawer>
        </div>
      ) : page === 4 ? (
        <div className="Game-Main-Div">
          <p className="Game-Text1">Catch the Falling Items </p>
          <p className="Game-Text2">
            Catch falling items with the basket. Increase your score by catching
            items. Avoid missing too many items to prevent game over.
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>
              1. Starting the Game:
            </span>{" "}
            Game starts immediately when the page loads.
            <br />
            <span style={{ fontWeight: "bold" }}>2. Move Basket:</span>
            Use left and right arrow keys to move the basket.
            <br />
            <span style={{ fontWeight: "bold" }}>3. Scoring:</span>
            Each caught item increases your score by 1.
            <br />
            <span style={{ fontWeight: "bold" }}>4. Missed Items:</span>
            Items that fall to the bottom without being caught are missed.
            Missing 200 items ends the game.
            <br />
            <span style={{ fontWeight: "bold" }}>5. Game Over:</span>
            A modal will show your final score and missed items. Choose to
            restart the game from the modal.
            <br />
            <span style={{ fontWeight: "bold" }}>6. Pause and Resume:</span>
            Click pause (||) to pause the game. Click resume (►) to continue
            playing.
            <br />
            <span style={{ fontWeight: "bold" }}>7. New Game:</span>
            When paused or game over, click "New Game" to restart with a new
            score and missed count.
            <br />
            <span style={{ fontWeight: "bold" }}>Tips:</span>
            Quickly move the basket using the arrow keys. Predict item
            trajectories for accurate catches. Minimize unnecessary movements
            for better control.
            <br />
            <br />
            Enjoy the game and aim for the highest score!
          </p>{" "}
          <button className="glow-on-hover" onClick={showDrawer4}>
            Lat's Playing
          </button>
          <Drawer
            title="Catch the Falling Items"
            onClose={onClose4}
            open={open4}
            className="custom-drawer"
            width="100%"
            bodyStyle={{
              padding: 0,
              backgroundColor: "#1b2840",
              color: "white",
            }}
            extra={
              <Space>
                <button className="Game-DrawerClose-Button" onClick={onClose4}>
                  Close
                </button>
              </Space>
            }
          >
            <Game4 />
          </Drawer>
        </div>
      ) : page === 5 ? (
        <div className="Game-Main-Div">
          <p className="Game-Text1">Snake Game</p>
          <p className="Game-Text2">
            Control the snake to eat food and score points. Avoid collisions
            with walls and the snake's own body.
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>
              1. Starting the Game:
            </span>{" "}
            Press the arrow keys to start moving the snake. Use the arrow keys
            to change the direction of the snake (up, down, left, right).
            <br />
            <span style={{ fontWeight: "bold" }}>2. Food:</span>
            Each piece of food eaten increases the snake's length by one segment
            and adds one point to your score. After every 5 points, a bonus food
            item appears, worth an extra 5 points, but only for 5 seconds.
            <br />
            <span style={{ fontWeight: "bold" }}>3. Speed Increase:</span>
            The snake's speed increases after every 5 points scored.
            <br />
            <span style={{ fontWeight: "bold" }}>4. Bonus Food:</span>
            Bonus food appears after every 5 points and lasts for 5 seconds.
            Eating bonus food adds 5 points to your score.
            <br />
            <span style={{ fontWeight: "bold" }}>5. Pause and Resume:</span>
            Use the pause button to pause the game at any time. Resume the game
            by clicking the resume button.
            <br />
            <span style={{ fontWeight: "bold" }}>6. Game Over:</span>
            The game ends if the snake collides with the walls or its own body.
            When the game is over, the final score is displayed. Use the restart
            button to start a new game.
            <br />
            <span style={{ fontWeight: "bold" }}>7. New Game:</span>
            The "New Game" button appears when the game is paused or over. Click
            it to start a new game.
            <br />
            <br />
            Enjoy playing and aim for the highest score!
            <br />
          </p>{" "}
          <button className="glow-on-hover" onClick={showDrawer5}>
            Lat's Playing
          </button>
          <Drawer
            title="Snake Game"
            onClose={onClose5}
            open={open5}
            className="custom-drawer"
            width="100%"
            bodyStyle={{
              padding: 0,
              backgroundColor: "#1b2840",
              color: "white",
            }}
            extra={
              <Space>
                <button className="Game-DrawerClose-Button" onClick={onClose5}>
                  Close
                </button>
              </Space>
            }
          >
            <Game5 />
          </Drawer>
        </div>
      ) : (
        <h1> Error page</h1>
      )}
    </div>
  );
}
